/* tslint:disable */
/* eslint-disable */
/**
 * Bill Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { AddBlockedUserScoreTransactionRequest } from '../model';
// @ts-ignore
import { AddBlockedUserScoreTransactionResponse } from '../model';
// @ts-ignore
import { AddBuyTransactionResponse } from '../model';
// @ts-ignore
import { AddManualTransactionScoreRequest } from '../model';
// @ts-ignore
import { ConvertRatioResponse } from '../model';
// @ts-ignore
import { GetUserScoreTransactionListRequest } from '../model';
// @ts-ignore
import { GetUserScoreTransactionResponse } from '../model';
// @ts-ignore
import { RecievedUserScoreResponse } from '../model';
// @ts-ignore
import { RemainingUserScoreTransactionResponse } from '../model';
// @ts-ignore
import { RemoveBlockedUserScoreTransactionRequest } from '../model';
// @ts-ignore
import { ServiceDiscountTypes } from '../model';
// @ts-ignore
import { SubtractBuyFromUserScoreTransactionRequest } from '../model';
// @ts-ignore
import { UserScoreBillResponse } from '../model';
// @ts-ignore
import { UserScoreBuyTransactionRequest } from '../model';
// @ts-ignore
import { UserScoreCancelTransactionRequset } from '../model';
// @ts-ignore
import { UserScoreLevelRange } from '../model';
// @ts-ignore
import { UserScoreResponse } from '../model';
// @ts-ignore
import { UserScoreTransactionResponse } from '../model';
// @ts-ignore
import { UserScoreWithdrawResponse } from '../model';
// @ts-ignore
import { VariationUserLevelResponse } from '../model';
/**
 * UserScoresApiApiBillsBillCodeApplicableUserScoreGet - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserScoresApiApiBillsBillCodeApplicableUserScoreGetAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiBillsBillCodeApplicableUserScoreGet', 'billCode', billCode)
    const localVarPath = `/api/Bills/{billCode}/ApplicableUserScore`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserScoresApiApiBillsBillCodeApplyServiceDiscountPost - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {ServiceDiscountTypes} [serviceDiscountType] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserScoresApiApiBillsBillCodeApplyServiceDiscountPostAxiosParamCreator (billCode: string, serviceDiscountType?: ServiceDiscountTypes, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiBillsBillCodeApplyServiceDiscountPost', 'billCode', billCode)
    const localVarPath = `/api/Bills/{billCode}/ApplyServiceDiscount`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (serviceDiscountType !== undefined) {
        localVarQueryParameter['serviceDiscountType'] = serviceDiscountType;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserScoresApiApiBillsBillCodeApplyUserScorePost - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserScoresApiApiBillsBillCodeApplyUserScorePostAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiBillsBillCodeApplyUserScorePost', 'billCode', billCode)
    const localVarPath = `/api/Bills/{billCode}/ApplyUserScore`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserScoresApiApiUserAddOperatorTransactionPost - axios parameter creator
 * 
 * @param {AddManualTransactionScoreRequest} [addManualTransactionScoreRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserScoresApiApiUserAddOperatorTransactionPostAxiosParamCreator (addManualTransactionScoreRequest?: AddManualTransactionScoreRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/User/addOperatorTransaction`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(addManualTransactionScoreRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserScoresApiApiUserGetConversionRatioGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserScoresApiApiUserGetConversionRatioGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/User/GetConversionRatio`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserScoresApiApiUserScoresAddBlockedUserScoreTransactionPost - axios parameter creator
 * 
 * @param {AddBlockedUserScoreTransactionRequest} [addBlockedUserScoreTransactionRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserScoresApiApiUserScoresAddBlockedUserScoreTransactionPostAxiosParamCreator (addBlockedUserScoreTransactionRequest?: AddBlockedUserScoreTransactionRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/UserScores/AddBlockedUserScoreTransaction`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(addBlockedUserScoreTransactionRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserScoresApiApiUserScoresBriefGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserScoresApiApiUserScoresBriefGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/UserScores/Brief`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserScoresApiApiUserScoresGet - axios parameter creator
 * 
 * @param {string} [from] 
 * @param {string} [to] 
 * @param {number} [userId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserScoresApiApiUserScoresGetAxiosParamCreator (from?: string, to?: string, userId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/UserScores`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (from !== undefined) {
        localVarQueryParameter['From'] = (from as any instanceof Date) ?
            (from as any).toISOString() :
            from;
    }

    if (to !== undefined) {
        localVarQueryParameter['To'] = (to as any instanceof Date) ?
            (to as any).toISOString() :
            to;
    }

    if (userId !== undefined) {
        localVarQueryParameter['userId'] = userId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserScoresApiApiUserScoresGetUserScoreGet - axios parameter creator
 * 
 * @param {number} [userId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserScoresApiApiUserScoresGetUserScoreGetAxiosParamCreator (userId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/UserScores/GetUserScore`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (userId !== undefined) {
        localVarQueryParameter['userId'] = userId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserScoresApiApiUserScoresGetUserScoreTransactionListPost - axios parameter creator
 * 
 * @param {GetUserScoreTransactionListRequest} [getUserScoreTransactionListRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserScoresApiApiUserScoresGetUserScoreTransactionListPostAxiosParamCreator (getUserScoreTransactionListRequest?: GetUserScoreTransactionListRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/UserScores/GetUserScoreTransactionList`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(getUserScoreTransactionListRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserScoresApiApiUserScoresLevelRangesGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserScoresApiApiUserScoresLevelRangesGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/UserScores/LevelRanges`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserScoresApiApiUserScoresReceivedGet - axios parameter creator
 * 
 * @param {string} [billCode] 
 * @param {number} [adultCount] 
 * @param {number} [childCount] 
 * @param {number} [infantCount] 
 * @param {string} [xPlayerID] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserScoresApiApiUserScoresReceivedGetAxiosParamCreator (billCode?: string, adultCount?: number, childCount?: number, infantCount?: number, xPlayerID?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/UserScores/received`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (billCode !== undefined) {
        localVarQueryParameter['billCode'] = billCode;
    }

    if (adultCount !== undefined) {
        localVarQueryParameter['adultCount'] = adultCount;
    }

    if (childCount !== undefined) {
        localVarQueryParameter['childCount'] = childCount;
    }

    if (infantCount !== undefined) {
        localVarQueryParameter['infantCount'] = infantCount;
    }

    if (xPlayerID != null) {
        localVarHeaderParameter['X-PlayerID'] = String(xPlayerID);
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserScoresApiApiUserScoresRecievedGet - axios parameter creator
 * 
 * @param {string} [billCode] 
 * @param {number} [adultCount] 
 * @param {number} [childCount] 
 * @param {number} [infantCount] 
 * @param {string} [xPlayerID] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserScoresApiApiUserScoresRecievedGetAxiosParamCreator (billCode?: string, adultCount?: number, childCount?: number, infantCount?: number, xPlayerID?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/UserScores/recieved`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (billCode !== undefined) {
        localVarQueryParameter['billCode'] = billCode;
    }

    if (adultCount !== undefined) {
        localVarQueryParameter['adultCount'] = adultCount;
    }

    if (childCount !== undefined) {
        localVarQueryParameter['childCount'] = childCount;
    }

    if (infantCount !== undefined) {
        localVarQueryParameter['infantCount'] = infantCount;
    }

    if (xPlayerID != null) {
        localVarHeaderParameter['X-PlayerID'] = String(xPlayerID);
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserScoresApiApiUserScoresRefundCouponCodeDelete - axios parameter creator
 * 
 * @param {string} couponCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserScoresApiApiUserScoresRefundCouponCodeDeleteAxiosParamCreator (couponCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'couponCode' is not null or undefined
    assertParamExists('apiUserScoresRefundCouponCodeDelete', 'couponCode', couponCode)
    const localVarPath = `/api/UserScores/Refund/{couponCode}`
        .replace(`{${"couponCode"}}`, encodeURIComponent(String(couponCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserScoresApiApiUserScoresRegisterBuyScorePost - axios parameter creator
 * 
 * @param {UserScoreBuyTransactionRequest} [userScoreBuyTransactionRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserScoresApiApiUserScoresRegisterBuyScorePostAxiosParamCreator (userScoreBuyTransactionRequest?: UserScoreBuyTransactionRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/UserScores/RegisterBuyScore`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(userScoreBuyTransactionRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserScoresApiApiUserScoresRegisterCancelScorePost - axios parameter creator
 * 
 * @param {UserScoreCancelTransactionRequset} [userScoreCancelTransactionRequset] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserScoresApiApiUserScoresRegisterCancelScorePostAxiosParamCreator (userScoreCancelTransactionRequset?: UserScoreCancelTransactionRequset, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/UserScores/RegisterCancelScore`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(userScoreCancelTransactionRequset, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserScoresApiApiUserScoresRemoveBlockedUserScoreTransactionPost - axios parameter creator
 * 
 * @param {RemoveBlockedUserScoreTransactionRequest} [removeBlockedUserScoreTransactionRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserScoresApiApiUserScoresRemoveBlockedUserScoreTransactionPostAxiosParamCreator (removeBlockedUserScoreTransactionRequest?: RemoveBlockedUserScoreTransactionRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/UserScores/RemoveBlockedUserScoreTransaction`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(removeBlockedUserScoreTransactionRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserScoresApiApiUserScoresReportGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserScoresApiApiUserScoresReportGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/UserScores/report`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserScoresApiApiUserScoresSubtractBuyScoreFromUserScorePost - axios parameter creator
 * 
 * @summary subtract score when user buy ticket and get off from user score (coupon service have to call it)
 * @param {SubtractBuyFromUserScoreTransactionRequest} [subtractBuyFromUserScoreTransactionRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserScoresApiApiUserScoresSubtractBuyScoreFromUserScorePostAxiosParamCreator (subtractBuyFromUserScoreTransactionRequest?: SubtractBuyFromUserScoreTransactionRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/UserScores/SubtractBuyScoreFromUserScore`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(subtractBuyFromUserScoreTransactionRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserScoresApiApiUserScoresVariationGet - axios parameter creator
 * 
 * @param {string} [mobile] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserScoresApiApiUserScoresVariationGetAxiosParamCreator (mobile?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/UserScores/Variation`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (mobile !== undefined) {
        localVarQueryParameter['mobile'] = mobile;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiBillsBillCodeApplicableUserScoreGet operation in UserScoresApi.
 * @export
 * @interface UserScoresApiApiBillsBillCodeApplicableUserScoreGetRequest
 */
export interface UserScoresApiApiBillsBillCodeApplicableUserScoreGetRequest {
    /**
     * 
     * @type {string}
     * @memberof UserScoresApiApiBillsBillCodeApplicableUserScoreGet
     */
    readonly billCode: string
}

/**
 * Request parameters for apiBillsBillCodeApplyServiceDiscountPost operation in UserScoresApi.
 * @export
 * @interface UserScoresApiApiBillsBillCodeApplyServiceDiscountPostRequest
 */
export interface UserScoresApiApiBillsBillCodeApplyServiceDiscountPostRequest {
    /**
     * 
     * @type {string}
     * @memberof UserScoresApiApiBillsBillCodeApplyServiceDiscountPost
     */
    readonly billCode: string

    /**
     * 
     * @type {ServiceDiscountTypes}
     * @memberof UserScoresApiApiBillsBillCodeApplyServiceDiscountPost
     */
    readonly serviceDiscountType?: ServiceDiscountTypes
}

/**
 * Request parameters for apiBillsBillCodeApplyUserScorePost operation in UserScoresApi.
 * @export
 * @interface UserScoresApiApiBillsBillCodeApplyUserScorePostRequest
 */
export interface UserScoresApiApiBillsBillCodeApplyUserScorePostRequest {
    /**
     * 
     * @type {string}
     * @memberof UserScoresApiApiBillsBillCodeApplyUserScorePost
     */
    readonly billCode: string
}

/**
 * Request parameters for apiUserAddOperatorTransactionPost operation in UserScoresApi.
 * @export
 * @interface UserScoresApiApiUserAddOperatorTransactionPostRequest
 */
export interface UserScoresApiApiUserAddOperatorTransactionPostRequest {
    /**
     * 
     * @type {AddManualTransactionScoreRequest}
     * @memberof UserScoresApiApiUserAddOperatorTransactionPost
     */
    readonly addManualTransactionScoreRequest?: AddManualTransactionScoreRequest
}

/**
 * Request parameters for apiUserScoresAddBlockedUserScoreTransactionPost operation in UserScoresApi.
 * @export
 * @interface UserScoresApiApiUserScoresAddBlockedUserScoreTransactionPostRequest
 */
export interface UserScoresApiApiUserScoresAddBlockedUserScoreTransactionPostRequest {
    /**
     * 
     * @type {AddBlockedUserScoreTransactionRequest}
     * @memberof UserScoresApiApiUserScoresAddBlockedUserScoreTransactionPost
     */
    readonly addBlockedUserScoreTransactionRequest?: AddBlockedUserScoreTransactionRequest
}

/**
 * Request parameters for apiUserScoresGet operation in UserScoresApi.
 * @export
 * @interface UserScoresApiApiUserScoresGetRequest
 */
export interface UserScoresApiApiUserScoresGetRequest {
    /**
     * 
     * @type {string}
     * @memberof UserScoresApiApiUserScoresGet
     */
    readonly from?: string

    /**
     * 
     * @type {string}
     * @memberof UserScoresApiApiUserScoresGet
     */
    readonly to?: string

    /**
     * 
     * @type {number}
     * @memberof UserScoresApiApiUserScoresGet
     */
    readonly userId?: number
}

/**
 * Request parameters for apiUserScoresGetUserScoreGet operation in UserScoresApi.
 * @export
 * @interface UserScoresApiApiUserScoresGetUserScoreGetRequest
 */
export interface UserScoresApiApiUserScoresGetUserScoreGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UserScoresApiApiUserScoresGetUserScoreGet
     */
    readonly userId?: number
}

/**
 * Request parameters for apiUserScoresGetUserScoreTransactionListPost operation in UserScoresApi.
 * @export
 * @interface UserScoresApiApiUserScoresGetUserScoreTransactionListPostRequest
 */
export interface UserScoresApiApiUserScoresGetUserScoreTransactionListPostRequest {
    /**
     * 
     * @type {GetUserScoreTransactionListRequest}
     * @memberof UserScoresApiApiUserScoresGetUserScoreTransactionListPost
     */
    readonly getUserScoreTransactionListRequest?: GetUserScoreTransactionListRequest
}

/**
 * Request parameters for apiUserScoresReceivedGet operation in UserScoresApi.
 * @export
 * @interface UserScoresApiApiUserScoresReceivedGetRequest
 */
export interface UserScoresApiApiUserScoresReceivedGetRequest {
    /**
     * 
     * @type {string}
     * @memberof UserScoresApiApiUserScoresReceivedGet
     */
    readonly billCode?: string

    /**
     * 
     * @type {number}
     * @memberof UserScoresApiApiUserScoresReceivedGet
     */
    readonly adultCount?: number

    /**
     * 
     * @type {number}
     * @memberof UserScoresApiApiUserScoresReceivedGet
     */
    readonly childCount?: number

    /**
     * 
     * @type {number}
     * @memberof UserScoresApiApiUserScoresReceivedGet
     */
    readonly infantCount?: number

    /**
     * 
     * @type {string}
     * @memberof UserScoresApiApiUserScoresReceivedGet
     */
    readonly xPlayerID?: string
}

/**
 * Request parameters for apiUserScoresRecievedGet operation in UserScoresApi.
 * @export
 * @interface UserScoresApiApiUserScoresRecievedGetRequest
 */
export interface UserScoresApiApiUserScoresRecievedGetRequest {
    /**
     * 
     * @type {string}
     * @memberof UserScoresApiApiUserScoresRecievedGet
     */
    readonly billCode?: string

    /**
     * 
     * @type {number}
     * @memberof UserScoresApiApiUserScoresRecievedGet
     */
    readonly adultCount?: number

    /**
     * 
     * @type {number}
     * @memberof UserScoresApiApiUserScoresRecievedGet
     */
    readonly childCount?: number

    /**
     * 
     * @type {number}
     * @memberof UserScoresApiApiUserScoresRecievedGet
     */
    readonly infantCount?: number

    /**
     * 
     * @type {string}
     * @memberof UserScoresApiApiUserScoresRecievedGet
     */
    readonly xPlayerID?: string
}

/**
 * Request parameters for apiUserScoresRefundCouponCodeDelete operation in UserScoresApi.
 * @export
 * @interface UserScoresApiApiUserScoresRefundCouponCodeDeleteRequest
 */
export interface UserScoresApiApiUserScoresRefundCouponCodeDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof UserScoresApiApiUserScoresRefundCouponCodeDelete
     */
    readonly couponCode: string
}

/**
 * Request parameters for apiUserScoresRegisterBuyScorePost operation in UserScoresApi.
 * @export
 * @interface UserScoresApiApiUserScoresRegisterBuyScorePostRequest
 */
export interface UserScoresApiApiUserScoresRegisterBuyScorePostRequest {
    /**
     * 
     * @type {UserScoreBuyTransactionRequest}
     * @memberof UserScoresApiApiUserScoresRegisterBuyScorePost
     */
    readonly userScoreBuyTransactionRequest?: UserScoreBuyTransactionRequest
}

/**
 * Request parameters for apiUserScoresRegisterCancelScorePost operation in UserScoresApi.
 * @export
 * @interface UserScoresApiApiUserScoresRegisterCancelScorePostRequest
 */
export interface UserScoresApiApiUserScoresRegisterCancelScorePostRequest {
    /**
     * 
     * @type {UserScoreCancelTransactionRequset}
     * @memberof UserScoresApiApiUserScoresRegisterCancelScorePost
     */
    readonly userScoreCancelTransactionRequset?: UserScoreCancelTransactionRequset
}

/**
 * Request parameters for apiUserScoresRemoveBlockedUserScoreTransactionPost operation in UserScoresApi.
 * @export
 * @interface UserScoresApiApiUserScoresRemoveBlockedUserScoreTransactionPostRequest
 */
export interface UserScoresApiApiUserScoresRemoveBlockedUserScoreTransactionPostRequest {
    /**
     * 
     * @type {RemoveBlockedUserScoreTransactionRequest}
     * @memberof UserScoresApiApiUserScoresRemoveBlockedUserScoreTransactionPost
     */
    readonly removeBlockedUserScoreTransactionRequest?: RemoveBlockedUserScoreTransactionRequest
}

/**
 * Request parameters for apiUserScoresSubtractBuyScoreFromUserScorePost operation in UserScoresApi.
 * @export
 * @interface UserScoresApiApiUserScoresSubtractBuyScoreFromUserScorePostRequest
 */
export interface UserScoresApiApiUserScoresSubtractBuyScoreFromUserScorePostRequest {
    /**
     * 
     * @type {SubtractBuyFromUserScoreTransactionRequest}
     * @memberof UserScoresApiApiUserScoresSubtractBuyScoreFromUserScorePost
     */
    readonly subtractBuyFromUserScoreTransactionRequest?: SubtractBuyFromUserScoreTransactionRequest
}

/**
 * Request parameters for apiUserScoresVariationGet operation in UserScoresApi.
 * @export
 * @interface UserScoresApiApiUserScoresVariationGetRequest
 */
export interface UserScoresApiApiUserScoresVariationGetRequest {
    /**
     * 
     * @type {string}
     * @memberof UserScoresApiApiUserScoresVariationGet
     */
    readonly mobile?: string
}

/**
* 
* @param {UserScoresApiApiBillsBillCodeApplicableUserScoreGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserScoresApiApiBillsBillCodeApplicableUserScoreGet(requestParameters: UserScoresApiApiBillsBillCodeApplicableUserScoreGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserScoresApiApiBillsBillCodeApplicableUserScoreGetAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<UserScoreBillResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {UserScoresApiApiBillsBillCodeApplyServiceDiscountPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserScoresApiApiBillsBillCodeApplyServiceDiscountPost(requestParameters: UserScoresApiApiBillsBillCodeApplyServiceDiscountPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserScoresApiApiBillsBillCodeApplyServiceDiscountPostAxiosParamCreator(requestParameters.billCode, requestParameters.serviceDiscountType, options, configuration);
    const request: () => AxiosPromise<UserScoreWithdrawResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {UserScoresApiApiBillsBillCodeApplyUserScorePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserScoresApiApiBillsBillCodeApplyUserScorePost(requestParameters: UserScoresApiApiBillsBillCodeApplyUserScorePostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserScoresApiApiBillsBillCodeApplyUserScorePostAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<UserScoreWithdrawResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {UserScoresApiApiUserAddOperatorTransactionPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserScoresApiApiUserAddOperatorTransactionPost(requestParameters: UserScoresApiApiUserAddOperatorTransactionPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserScoresApiApiUserAddOperatorTransactionPostAxiosParamCreator(requestParameters.addManualTransactionScoreRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserScoresApiApiUserGetConversionRatioGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserScoresApiApiUserGetConversionRatioGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<ConvertRatioResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {UserScoresApiApiUserScoresAddBlockedUserScoreTransactionPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserScoresApiApiUserScoresAddBlockedUserScoreTransactionPost(requestParameters: UserScoresApiApiUserScoresAddBlockedUserScoreTransactionPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserScoresApiApiUserScoresAddBlockedUserScoreTransactionPostAxiosParamCreator(requestParameters.addBlockedUserScoreTransactionRequest, options, configuration);
    const request: () => AxiosPromise<AddBlockedUserScoreTransactionResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserScoresApiApiUserScoresBriefGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserScoresApiApiUserScoresBriefGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<UserScoreResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {UserScoresApiApiUserScoresGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserScoresApiApiUserScoresGet(requestParameters: UserScoresApiApiUserScoresGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserScoresApiApiUserScoresGetAxiosParamCreator(requestParameters.from, requestParameters.to, requestParameters.userId, options, configuration);
    const request: () => AxiosPromise<Array<UserScoreTransactionResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {UserScoresApiApiUserScoresGetUserScoreGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserScoresApiApiUserScoresGetUserScoreGet(requestParameters: UserScoresApiApiUserScoresGetUserScoreGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserScoresApiApiUserScoresGetUserScoreGetAxiosParamCreator(requestParameters.userId, options, configuration);
    const request: () => AxiosPromise<UserScoreResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {UserScoresApiApiUserScoresGetUserScoreTransactionListPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserScoresApiApiUserScoresGetUserScoreTransactionListPost(requestParameters: UserScoresApiApiUserScoresGetUserScoreTransactionListPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserScoresApiApiUserScoresGetUserScoreTransactionListPostAxiosParamCreator(requestParameters.getUserScoreTransactionListRequest, options, configuration);
    const request: () => AxiosPromise<Array<GetUserScoreTransactionResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserScoresApiApiUserScoresLevelRangesGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserScoresApiApiUserScoresLevelRangesGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<Array<UserScoreLevelRange>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {UserScoresApiApiUserScoresReceivedGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserScoresApiApiUserScoresReceivedGet(requestParameters: UserScoresApiApiUserScoresReceivedGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserScoresApiApiUserScoresReceivedGetAxiosParamCreator(requestParameters.billCode, requestParameters.adultCount, requestParameters.childCount, requestParameters.infantCount, requestParameters.xPlayerID, options, configuration);
    const request: () => AxiosPromise<RecievedUserScoreResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {UserScoresApiApiUserScoresRecievedGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserScoresApiApiUserScoresRecievedGet(requestParameters: UserScoresApiApiUserScoresRecievedGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserScoresApiApiUserScoresRecievedGetAxiosParamCreator(requestParameters.billCode, requestParameters.adultCount, requestParameters.childCount, requestParameters.infantCount, requestParameters.xPlayerID, options, configuration);
    const request: () => AxiosPromise<RecievedUserScoreResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {UserScoresApiApiUserScoresRefundCouponCodeDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserScoresApiApiUserScoresRefundCouponCodeDelete(requestParameters: UserScoresApiApiUserScoresRefundCouponCodeDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserScoresApiApiUserScoresRefundCouponCodeDeleteAxiosParamCreator(requestParameters.couponCode, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {UserScoresApiApiUserScoresRegisterBuyScorePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserScoresApiApiUserScoresRegisterBuyScorePost(requestParameters: UserScoresApiApiUserScoresRegisterBuyScorePostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserScoresApiApiUserScoresRegisterBuyScorePostAxiosParamCreator(requestParameters.userScoreBuyTransactionRequest, options, configuration);
    const request: () => AxiosPromise<AddBuyTransactionResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {UserScoresApiApiUserScoresRegisterCancelScorePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserScoresApiApiUserScoresRegisterCancelScorePost(requestParameters: UserScoresApiApiUserScoresRegisterCancelScorePostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserScoresApiApiUserScoresRegisterCancelScorePostAxiosParamCreator(requestParameters.userScoreCancelTransactionRequset, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {UserScoresApiApiUserScoresRemoveBlockedUserScoreTransactionPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserScoresApiApiUserScoresRemoveBlockedUserScoreTransactionPost(requestParameters: UserScoresApiApiUserScoresRemoveBlockedUserScoreTransactionPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserScoresApiApiUserScoresRemoveBlockedUserScoreTransactionPostAxiosParamCreator(requestParameters.removeBlockedUserScoreTransactionRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserScoresApiApiUserScoresReportGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserScoresApiApiUserScoresReportGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<RemainingUserScoreTransactionResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary subtract score when user buy ticket and get off from user score (coupon service have to call it)
* @param {UserScoresApiApiUserScoresSubtractBuyScoreFromUserScorePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserScoresApiApiUserScoresSubtractBuyScoreFromUserScorePost(requestParameters: UserScoresApiApiUserScoresSubtractBuyScoreFromUserScorePostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserScoresApiApiUserScoresSubtractBuyScoreFromUserScorePostAxiosParamCreator(requestParameters.subtractBuyFromUserScoreTransactionRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {UserScoresApiApiUserScoresVariationGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserScoresApiApiUserScoresVariationGet(requestParameters: UserScoresApiApiUserScoresVariationGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserScoresApiApiUserScoresVariationGetAxiosParamCreator(requestParameters.mobile, options, configuration);
    const request: () => AxiosPromise<VariationUserLevelResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
